import Vue from "vue";
import axios from "axios";
import { i18n } from "@/i18n/i18n.js";
import config from "@/config"

const state = {
    company: {
        lines: [],
        country: [null, ""],
        region_default: [null, ""],
        region_choices: [],
        discount_group_default: [null, ""],
        discount_group_choices: [],
        assortment_default: [null, ""],
        assortment_choices: [],
        language: [null, ""],
        language_choices: [],
    },
    companyName: localStorage.getItem ("companyName") || "",
    subCompanies: [],
    subCompaniesGeneral: [],
    priceLogLoading: false,
    priceLogs: [],
    pageCount: 0,
    priceLogsTotal: 0,
    detailPrice: [],
    countries: [],
    deliveryAdresses: [],
    countryCodesAdress: [],
    deliveryEdit: {},
    companyRoot: { children: [] },
    companiesLoading: false,
    saveDeliveryActive: false,
    saveCompanyActive:false,
    possibleParents: [],
    currentParent: null,
    deliveryRedirect: ""
};

const getters = {
    getPossibleParents (state) { return state.possibleParents},
    getCurrentParent   (state) { return state.currentParent},
    getCurrentCompany(state) {
        return state.company
    },
    getCompanyName () {
        return state.companyName
    },
    getSubCompanies(state) {
        if (state.subCompanies == undefined)
            return undefined
        var x = Object.assign({}, state.subCompanies)
        return x
    },
    getSubCompaniesGeneral(state) {
        var y = {}
        if (state.company) {
            y.name1 = state.company.name1
            if (state.subCompaniesGeneral.length > 0) {
                y.has_children = state.subCompaniesGeneral
            }
        }
        return y
    },
    getPriceLogloading(state) {
        return state.priceLogLoading
    },
    getPriceLogs(state) {
        return state.priceLogs
    },
    getDetailPrice(state) {
        return state.detailPrice
    },
    getPageCount(state) {
        return state.pageCount
    },
    getPriceLogTotal(state) {
        return state.priceLogsTotal
    },
    getCountries(state) {
        return state.countries
    },
    getDeliveryAdresses(state) {
        return state.deliveryAdresses
    },
    getCountryCodesAdress(state) {
        return state.countryCodesAdress
    },
    getDeliveryEdit(state) {
        return state.deliveryEdit
    },
    getCompanyRoot(state) {
        return state.companyRoot
    },
    getCompaniesLoading(state) {
        return state.companiesLoading
    },
    saveDeliveryActive(state) {
        return state.saveDeliveryActive
    },
    saveCompanyActive(state) {
        return state.saveCompanyActive
    },
    getDeliveryRedirect(state) {
      return state.deliveryRedirect
    }
}

const actions = {
    setNewParent({getters}, {self, parent, company}) {
        const formData = new FormData ()
        formData.append ("parent", parent)
        return axios.post (`/vue/company/${company}/set-parent/`, formData,
                { headers: { Authorization: "Token " + getters.getUserToken } }
            ).then (resp => {
                const data = resp.data
                if (! data.status) {
                    const messages = data.messages.join ("<br>")
                    return self.$toastr("error", messages, i18n.t("error"))
                } else {
                    self.$router.push ({ name: "my-company"})
                }
            }).catch(err => {
                self.$toastr ("error", err.message, i18n.t("error"))
            })
    },

  changeDeliveryAddress ({ getters, commit}, data) {
        state.saveDeliveryActive = true
        return axios
        .post (`/vue/company/${data.cid}/address/${data.id}/set-delivery/`,
            {},
            { headers: { Authorization: "Token " + getters.getUserToken } }
        )
        .then(response => {
            state.saveDeliveryActive = false
            if (!response.data.status) {
                const messages = data.messages.join ("<br>")
                return data.self.$toastr("error", messages, i18n.t("error"));
            } else {
                data.self.$toastr("success", i18n.t("delivery-changed"), i18n.t("success"));
                commit("CHANGE_DELIVERY_ADDRESS", response.data.data)
            }
        })
        .catch(err => {
            state.saveDeliveryActive = false
            data.self.$toastr("error", err.message, i18n.t("error"));
        });
  },
  saveEditdelivery({ getters }, data) {
    state.saveDeliveryActive = true
    return axios
      .post(
        "/vue/company/" + data.cid + "/address/" + data.address + "/edit/",
        state.deliveryEdit,
        { headers: { Authorization: "Token " + getters.getUserToken } }
      )
      .then(response => {
        state.saveDeliveryActive = false
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          data.self.$router.push({ name: "delivery-overview" });
          data.self.$toastr("success", i18n.t("saved"), i18n.t("success"));
        }
      })
      .catch(err => {
        state.saveDeliveryActive = false
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  callDeliveryEdit({ commit, getters }, data) {
    return axios
      .get("/vue/company/" + data.company + "/delivery-addresses/", {
        headers: { Authorization: "Token " + getters.getUserToken }
      })
      .then(response => {
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          var addresses = response.data.data.addresses;
          var address = addresses.find(x => x.id == data.address);
          commit("SET_DELIVERYEDIT", address);
        }
      })
      .catch(err => {
        data.self.$toastr("error", err.message, "Error");
      });
  },
  createDeliveryAdress({ getters }, data) {
    return axios
      .post("/vue/company/" + data.cid + "/address/new/", data.delivery, {
        headers: { Authorization: "Token " + getters.getUserToken }
      })
      .then(response => {
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, "Error");
        } else {
            data.self.$router.push({ name: "delivery-overview" });
            data.self.$toastr("success", i18n.t("saved"), i18n.t("success"));
        }
      })
      .catch(err => {
        data.self.$toastr("error", err.message, "Error");
      });
  },
  callDeliveryAdresses({ commit, getters }, data) {
    if (data.redirect !== undefined)
        commit ("SET_DELIVERY_REDIRECT", data.redirect)
    return axios
      .get("/vue/company/" + data.company + "/delivery-addresses/", {
        headers: { Authorization: "Token " + getters.getUserToken }
      })
      .then(response => {
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          commit("SET_DELIVERYADRESSES", response.data.data.addresses);
          commit("SET_COUNTRYCODESADDRESS", response.data.data.country_choices);
        }
      })
      .catch(err => {
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  callCurrentCompany({ commit, getters, dispatch }, data) {
    var lines_temp = [];
    if (! data.company) {
        console.log ("*** NO Company defined")
        return
    }
    return axios
      .get("/vue/company/" + data.company + "/info/", {
        headers: { Authorization: "Token " + getters.getUserToken }
      })
      .then(response => {
        if (!response) {
          dispatch("logout");
        }
        if (response.data.data.line_default != undefined) {
          response.data.data.line_default.pop();
        }

        for (var i = 0; i < response.data.data.lines.length; i++) {
          lines_temp[i] = response.data.data.lines[i][0];
        }
        commit ("SET_LINES",        {lines: response.data.data.lines, active: response.data.data.last_line})
        response.data.data.lines = lines_temp;
        if (response.data.data.region_default) {
          response.data.data.region_default.pop();
        }

        if (response.data.data.language == null) {
          response.data.data.language = [];
        }
        commit ("SET_COMPANY_DATA", response.data.data)
        commit ("SET_COMPANY",      response.data.data.id)
        return true;
      });
  },

  saveEditCompany({ getters }, data) {
    state.saveCompanyActive = true
    state.company.assortment = state.company.assortment[0];
    state.company.discount_group = state.company.discount_group[0];
    state.company.language = state.company.language[0];
    if (state.company.parent) {
      state.company.parent = state.company.parent[0];
    }
    state.company.region = state.company.region[0];
    state.company.country = state.company.country[0];
    console.log ("saveEditCompany", state.company)
    const json = JSON.stringify (state.company)
    const blob = new Blob([json], {
        type: 'application/json'
      });
    const formData = new FormData ()
    formData.append ("document", blob)
    formData.append ("logo",    data.logo)
    return axios
      .post (
          "/vue/company/" + data.company + "/edit/",
          formData,
          { headers: { Authorization: "Token " + getters.getUserToken }
       })
      .then(response => {
        state.saveCompanyActive = false
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          this.dispatch("callCurrentCompany", {
            self: data.self,
            company: data.company
          });
          data.self.$toastr("success", i18n.t("saved"), i18n.t("success"));
        }
      })
      .catch(err => {
        state.saveCompanyActive = false
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  createCompany({ getters }, data) {
    state.saveCompanyActive = true
    data.company.lines = state.company.line_default;
    return axios
      .post(
        "/vue/company/" + data.cid + "/create/sub-company/",
        data.company,
        { headers: { Authorization: "Token " + getters.getUserToken } }
      )
      .then(response => {
        state.saveCompanyActive = false
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
            data.self.$router.push({ name: "my-company" });
            data.self.$toastr("success", i18n.t("saved"), i18n.t("success"));
        }
      })
      .catch(err => {
        state.saveCompanyActive = false
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
    },
    uploadPrice({ getters }, {self, files}) {
        const formData = new FormData ()
        formData.append ("prices", files [0])

        return axios
            .post("/vue/price/upload/", formData, {
                headers: {
                    Authorization: "Token " + getters.getUserToken,
                    "Content-Type": "multipart/form-data"
                }
            }).then(response => {
                self.isActive = !self.isActive
                if (!response.data.status) {
                    let messages = response.data.messages.join ("<br>")
                    return self.$toastr("error", messages, i18n.t("error"))
                } else {
                    const pl = response.data.data
                    return self.$toastr (
                        "success",
                        `Changed: ${pl.changed}<br> New: ${pl.new}<br> Unchanged: ${pl.unchanged}`,
                        "Success")
                }
            }).catch(err => {
                self.isActive = !self.isActive;
                return self.$toastr ("error", err.message, i18n.t("error"))
        })
    },
    uploadVartext ({ getters }, { self, files }) {
        const formData = new FormData ()
        formData.append ("file", files [0])

        return axios
            .post ("/vue/i18n/vartext-xml/", formData, {
                headers: {
                    Authorization: "Token " + getters.getUserToken,
                    "Content-Type": "multipart/form-data"
                }
            }).then (response => {
                self.isActive = !self.isActive
                if (!response.data.status) {
                    let messages = response.data.messages.join ("<br>")
                    return self.$toastr("error", messages, i18n.t("error"))
                } else {
                    const pl = response.data.data
                    return self.$toastr (
                        "success", `Upload successfull`, "Success")
                }
            })
            .catch(err => {
                self.isActive = !self.isActive;
                return self.$toastr("error", err.message, i18n.t("error"));
            });
  },
  loadPossibleParents ({getters, commit}, {self, company}) {
      return axios
          .get (`/vue/company/${company}/set-parent/`, {
               headers: { Authorization: "Token " + getters.getUserToken }
            }).then (resp => {
                const data = resp.data
                if (data.status) {
                    commit ("setPossibleParents", {
                        children: data.data.children,
                        current: data.data.current
                    })
                } else {
                    let messages = resp.data.messages.join ("<br>")
                    return self.$toastr("error", messages, i18n.t("error"))
                }
            }).catch(err => {
                return self.$toastr("error", err.message, i18n.t("error"));
            })
  },
  shopClicked({ commit }, cid) {
      commit ("SHOP_AS", cid)
  },
  shopDeliveryClicked({commit}, {url}) {
    commit ("SET_DELIVERY_REDIRECT", "")
    window.location.href = url
  },
  searchCompanies({ commit, getters }, data) {
    state.companiesLoading = true;
    return axios
      .get(
        "/vue/company/" + data.company + "/search2/?search=" + data.search,
        { headers: { Authorization: "Token " + getters.getUserToken } }
      )
      .then(response => {
        state.companiesLoading = false;
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          let rdata = response.data.data;
          if (rdata.found.length > 0) {
            commit("SET_COMANY_ROOT", rdata.companies[0]);
            data.self.$toastr(
              "success",
              i18n.t("companies-found"),
              i18n.t("success")
            );
          } else {
            data.self.$toastr(
              "info",
              i18n.t("no-companies-found"),
              i18n.t("info")
            );
          }
        }
      })
      .catch(err => {
        state.companiesLoading = false;
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  callCountries({ commit }, data) {
    return axios
      .get("/vue/country-codes/")
      .then(response => {
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          commit("SET_COUNTRIES", response.data.data.country_choices);
        }
      })
      .catch(err => {
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  callPriceLogs({ commit, getters }, data) {
    return axios
      .get(
          "/vue/price/logs/?number_per_page=" +
          data.perPage +
          "&page=" +
          data.pageNum +
          "&sort=" +
          data.sortOrder +
          data.sortField +
          "&filter=" +
          data.filter,
        { headers: { Authorization: "Token " + getters.getUserToken } }
      )
      .then(response => {
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          commit("SET_PAGECOUNT", response.data.data.pages);
          commit("SET_PRICELOG_TOTAL", response.data.data.no_of_logs);
          commit("SET_PRICELOGS", response.data.data.entries);
        }
      })
      .catch(err => {
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  callDetailPrice({ commit, getters }, data) {
    return axios
      .get("/vue/price/log/" + data.pid + "/", {
        headers: { Authorization: "Token " + getters.getUserToken }
      })
      .then(response => {
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          commit("SET_DETAILPRICE", response.data.data.rows);
        }
      })
      .catch(err => {
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  callSubCompanies({ commit, getters }, data) {
    state.subCompanies.push({ name: "Test", children: [] });
    state.companiesLoading = true;
    return axios
      .get("/vue/company/" + data.company + "/sub-companies2/", {
        headers: { Authorization: "Token " + getters.getUserToken },
        params: { root: "1" }
      })
      .then(response => {
        state.companiesLoading = false;
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          commit("SET_COMANY_ROOT", response.data.data.companies[0]);
        }
      })
      .catch(err => {
        state.companiesLoading = false;
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  callSubSubCompanies({ commit, getters }, data) {
    state.companiesLoading = true;
    return axios
      .get("/vue/company/" + data.company + "/sub-companies2/", {
        headers: { Authorization: "Token " + getters.getUserToken },
        params: { root: "0" }
      })
      .then(response => {
        state.companiesLoading = false;
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          let payload = {
            companies: response.data.data.companies,
            parent: data.self.node
          };
          commit("UPDATE_COMANY_ROOT", payload);
        }
      })
      .catch(err => {
        state.companiesLoading = false;
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  }
};

const mutations = {
    setPossibleParents(state, {children, current}) {
        state.possibleParents = children
        state.currentParent   = current
    },
    SET_COMPANY_DATA(state, payload) {
        state.company = payload;
        if (payload) {
            let companyName = state.company.name1
            if (state.company.name2)
                companyName = companyName + " " + state.company.name2
            state.companyName = companyName
            localStorage.setItem ("companyName", companyName)
        } else {
            localStorage.removeItem ("companyName")
            state.companyName = ""
        }
    },
    SET_SUBCOMPANIES(state, payload) {
        state.subCompanies = payload
    },
    SET_SUBCOMPANIESGENERAL(state, payload) {
        state.subCompaniesGeneral = payload
    },
    SET_PRICELOGS(state, payload) {
        state.priceLogs = payload
    },
    SET_DETAILPRICE(state, payload) {
        state.detailPrice = payload
    },
    SET_PAGECOUNT(state, payload) {
        state.pageCount = payload
    },
    SET_PRICELOG_TOTAL(state, payload) {
        state.priceLogsTotal = payload
    },
    SET_COUNTRIES(state, payload) {
        state.countries = payload
    },
    SET_DELIVERYADRESSES(state, payload) {
        state.deliveryAdresses = payload
    },
    SET_COUNTRYCODESADDRESS(state, payload) {
        state.countryCodesAdress = payload
    },
    SET_DELIVERYEDIT(state, payload) {
        state.deliveryEdit = payload
    },
    SET_COMANY_ROOT(state, companyRoot) {
        state.companyRoot = companyRoot
    },
    UPDATE_COMANY_ROOT(state, payload) {
        Vue.set (payload.parent, "children", payload.companies)
    },
    CHANGE_DELIVERY_ADDRESS(state, payload) {
        for (let i = 0; i < state.deliveryAdresses.length; i++) {
            let a = state.deliveryAdresses [i]
            if (a.id == payload.old) a.is_delivery = false
            if (a.id == payload.new) a.is_delivery = true
        }
    },
    SHOP_AS(_, cid) {
        let url = "/dealer/company/" + cid + "/shop/"
        if (config.skipLogout) {
            url += "?skipLogout=1"
        } else {
            localStorage.setItem ("useAs", true)
        }
        window.location.href = url
    },
    SET_DELIVERY_REDIRECT(state, value) {
        state.deliveryRedirect = value || ""
        if (value)
            localStorage.setItem ("deliveryRedirect", state.deliveryRedirect)
        else
        localStorage.removeItem ("deliveryRedirect")
      }
}

const companyModule = {
    state:      state,
    mutations:  mutations,
    actions,
    getters
};

export default companyModule;
